/**
 * Handles the dismissible welcome notice.
 */
export const initWelcomeNotice = () => {
    const notice = document.querySelector('.crsc-welcome-notice') as HTMLElement;
    const dismissButton = document.querySelector('.crsc-welcome-notice-dismiss') as HTMLButtonElement;

    if (!notice || !dismissButton) return;

    dismissButton.addEventListener('click', () => {
        // Hide the notice
        notice.style.display = 'none';

        // Set a cookie to suppress the message for 30 days
        const date = new Date();
        date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
        const expires = "; expires=" + date.toUTCString();
        document.cookie = "crsc_welcome_notice_dismissed=1" + expires + "; path=/";
    });
};
